import type { FieldValues } from "react-hook-form";
import type { ZodType, z } from "zod";

export type AnySchema = ZodType<FieldValues, FieldValues>;

export type InferFormValues<S extends ZodType> = z.input<S>;

export type InferValidatedValues<S extends ZodType> = z.output<S>;

export type UseFormWrapperOptions<S extends ZodType> = {
  schema: S;
  defaultValues?: Partial<InferFormValues<S>>;
  mode?: "onSubmit" | "onChange" | "onBlur" | "onTouched" | "all";
  reValidateMode?: "onChange" | "onBlur" | "onSubmit";
  rethrowSubmitError?: boolean;
};
